<template>
<div id="room-types" :class="{'pa-2 ma-2': $vuetify.breakpoint.smAndUp}">
    <im-header @add="addRoomType()" :loading="loading">
        <template v-slot:title>
            <span>{{ $t('room_types.title') }}</span>
        </template>
        <template v-slot:button-name>
            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('room_types.button.add_new') }}</span>
            <span v-else>{{ $t('room_types.button.add_new_short') }}</span>
        </template>
    </im-header>

    <v-container fluid>
        <v-row class="im-card-items">
            <template v-for="element in items">
                <v-col cols="12" sm="6" md="4" lg="3">
                    <im-room-type-item class="im-card" :key="element.id" :item="element" @edit="editRoomType(element)" />
                </v-col>
            </template>
        </v-row>
    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMRoomTypeItem from '../../components/items/RoomType/Cardv2.vue';



export default {
    props: ['hotel'],
    name: `room-types`,

    components: {
        'im-header': IMHeader,
        'im-table-header': IMTableHeader,
        'im-room-type-item': IMRoomTypeItem,
    },

    data() {
        return {
            items: [],
            loading: null,

        };
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                } else {
                    this.getItems();
                }
            },
            deep: true,
            immediate: true
        },

    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {

                });
        },

        getItems() {
            if(!this.hotel.id) {
                return;
            }
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // we are currently loading

            // prepare stamp
            let stamp = Date.now();

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        editRoomType(item) {
            if(item.name) {
                defaults.room_type_name = item.name;
            } else {
                defaults.room_type_name = this.$i18n.messages.ro.room_type_slug[item.slug];
            }
            this.$router.push({
                path: '/' + this.hotel.slug + '/room-types/' + item.id
            });
        },

        addRoomType() {
            defaults.room_type_name = "Adauga camera noua"
            this.$router.push({
                path: '/' + this.hotel.slug + '/room-types/create'
            });
        },

    }
};
</script>
